import { Component, OnInit, ViewChild, ElementRef } from '@angular/core'
import { SidemenuComponent } from '../sidemenu/sidemenu.component'

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit {
  @ViewChild(SidemenuComponent) menu: SidemenuComponent

  constructor() { }

  ngOnInit() {
  }

  toggleMenu () {
    this.menu.toggle()
  }

}
